module.exports = __webpack_public_path__ + "img/profile_sp.5e232014.png";